import { FC } from 'react';

import { OrderAddress, Quantity } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { MultiLineText } from '@ravago/shared/radiance/components/typography/components/MultiLineText/MultiLineText';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter, useTranslations } from '@ravago/shared/translations/client';

interface Props {
  deliveryDate: string;
  quantity: Quantity;
  deliveryAddress?: OrderAddress;
  additionalInfo: string;
}

const CallOffDeliveryInfo: FC<Props> = ({ deliveryDate, quantity, deliveryAddress, additionalInfo }: Props) => {
  const translate = useTranslations();
  const format = useFormatter();

  return (
    <Box direction="column">
      <Table stroked="horizontal" tableLayout="fixed" hover={false} rowDividers={false}>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.requested-delivery-date')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="small">{format.dateTime(deliveryDate)}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.quantity')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="small">{format.quantity(quantity)}</Typography>
            </TableCell>
          </TableRow>
          {deliveryAddress && (
            <TableRow>
              <TableCell>
                <Typography variant="small-highlight" color="primary">
                  {translate('page-consumer.call-off-agreement-flyout.delivery-address')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="small">
                  <MultiLineText text={deliveryAddress.htmlFormat} lineBreak="<br>" />
                </Typography>
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell>
              <Typography variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.additional-information')}
              </Typography>
            </TableCell>
            <TableCell wordBreak="all">
              <Typography variant="small">{additionalInfo}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default CallOffDeliveryInfo;
